import { Mail } from "lucide-react";
import { NewsletterSignup } from "./NewsletterSignup";

/**
 * Site-wide newsletter CTA banner. Rendered on every page by SiteShell, styled
 * as a high-contrast conversion banner so it reads as a call to action rather
 * than a footer afterthought.
 */
export function NewsletterSection({ productLabel }: { productLabel?: string }) {
  const headline = productLabel
    ? `${productLabel} rates, market shifts, and program changes — in your inbox.`
    : "Rates, market shifts, and program changes — in your inbox.";
  return (
    <section aria-labelledby="newsletter-heading" className="container mx-auto max-w-7xl px-4 py-12 md:py-16">
      <div className="relative overflow-hidden rounded-3xl border-2 border-brand-gold/50 bg-brand-gradient text-primary-foreground shadow-[0_20px_60px_-25px_rgba(0,0,0,0.55)]">
        <div
          aria-hidden
          className="pointer-events-none absolute -right-16 -top-24 h-72 w-72 rounded-full bg-brand-gold/20 blur-3xl"
        />
        <div className="relative grid gap-8 p-7 md:p-10 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-12">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-brand-gold px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-primary">
              <Mail className="h-3.5 w-3.5" aria-hidden />
              Investor newsletter
            </div>
            <h2
              id="newsletter-heading"
              className="mt-4 font-display text-2xl font-bold leading-tight md:text-4xl"
            >
              {headline}
            </h2>
            <p className="mt-3 max-w-xl text-primary-foreground/90">
              Periodic investor updates: rate movement, guideline and program changes, and market
              data refreshes. No spam, unsubscribe anytime.
            </p>
            <ul className="mt-5 grid gap-2 text-sm text-primary-foreground/90 sm:grid-cols-2">
              <li className="flex gap-2"><span aria-hidden className="text-brand-gold">✓</span> DSCR rate snapshots</li>
              <li className="flex gap-2"><span aria-hidden className="text-brand-gold">✓</span> Program &amp; guideline updates</li>
              <li className="flex gap-2"><span aria-hidden className="text-brand-gold">✓</span> Illustrative investor scenarios</li>
              <li className="flex gap-2"><span aria-hidden className="text-brand-gold">✓</span> Market data notes</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-primary-foreground/15 bg-background/95 p-5 text-foreground shadow-lg md:p-6">
            <div className="mb-3 font-display text-lg font-bold">Get the investor update</div>
            <NewsletterSignup />
          </div>
        </div>
      </div>
    </section>
  );
}
